<section class="astral-accordion-section">
  <h3 class="astral-section-heading astral-accordion-section__heading astral-heading-with-help">
    <span>{{ 'ERRAND_TAG.PROPERTY_RESPONSIBILITY' | translate }}</span>
    <astral-popover [helpText]="'PROPERTY.HELP_TEXT.FAULTNOTIFICATION_RECIPIENT'"></astral-popover>
  </h3>
  <div class="astral-stack-m">
    @for (row of rows; track row.form; let i = $index) {
      <div
        class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-s"
        [formGroup]="row.form"
      >
        @if (row.historicalReadonly) {
          <astral-chip labelKey="ERRAND_TAG.HISTORICAL_DISABLED_RESPONSIBILITY"></astral-chip>
        }
        <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select
            [span]="2"
            [control]="row.form.controls['errandSubCategoryId']"
            [itemsSource]="row.subcategorySelection"
          ></astral-select>
        </astral-layout-group>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-typeahead [control]="row.form.controls['resourceId']" [itemsSource]="row.resources"></astral-typeahead>
          <astral-typeahead [control]="row.form.controls['executorGroupId']" [itemsSource]="row.executorGroups"></astral-typeahead>
          <astral-typeahead [control]="row.form.controls['executorWebUserId']" [itemsSource]="row.executorWebUsers"></astral-typeahead>
          <div class="astral-form-adjacent-action astral-form-adjacent-action--end">
            <astral-button
              variant="secondary"
              type="button"
              icon="trash"
              labelKey="DELETE_BTN"
              [disabled]="row.historicalReadonly"
              (click)="remove(i)"
            ></astral-button>
          </div>
        </astral-layout-group>
      </div>
    }
    <div class="astral-form-actions astral-form-actions--start">
      <astral-button
        variant="primary"
        size="small"
        type="button"
        icon="plus"
        labelKey="ERRAND_TAG.ADD_RESPONSIBILITY"
        [disabled]="loading || saving || !canAddResponsibility"
        (click)="add()"
      ></astral-button>
    </div>
  </div>
</section>
